import * as React from 'react'
import Link from 'next/link'
import styled from 'styled-components'

import * as ds from '@bob/design-system'
import * as utils from '@owl-nest/utils'

import * as boutiqueUrl from '@boutique/url'
import * as entities from '@boutique/entities'

import * as bobUrl from '@bob/url'

type Context = 'article' | 'brand' | 'product'
type Tag = { kind?: string; name: string; slug: string }
type TagListProps = {
  context: Context
  tagList: Tag[]
}

export function TagList({ context, tagList }: TagListProps): React.ReactElement {
  return (
    <TagContainer>
      {tagList.map((tag) => {
        return (
          <Link href={getTagHref(context, tag)} key={tag.slug} prefetch={false} scroll legacyBehavior>
            <a>
              <ds.Tag variant="outlined">{tag.name}</ds.Tag>
            </a>
          </Link>
        )
      })}
    </TagContainer>
  )
}

function getTagHref(context: Context, tag: Tag): string {
  switch (context) {
    case 'article': {
      if (tag.kind === 'category') {
        return boutiqueUrl.products({
          query: {
            facetFilters: {
              [tag.kind]: tag.slug,
            },
          },
        }).path
      }

      return bobUrl.tag({ name: tag.name, slug: tag.slug }).path
    }

    case 'brand': {
      return bobUrl.tag({ name: tag.name, slug: tag.slug }).path
    }

    case 'product': {
      const filter = tag.kind === undefined ? undefined : KIND_MAPPING[tag.kind]

      if (!filter)
        return boutiqueUrl.products({
          query: { searchableTag: utils.text.slugify(tag.name, ' ') },
        }).path

      return boutiqueUrl.products({
        query: {
          facetFilters: {
            [filter]: (entities.search.product.ARRAY_FILTERS as readonly string[]).includes(filter)
              ? [tag.slug]
              : tag.slug,
          },
        },
      }).path
    }
  }
}

const KIND_MAPPING: Record<string, keyof entities.search.product.Filters> = {
  types: 'types',
  environmentalPillar: 'environmentalPillars',
  socialPillar: 'socialPillars',
}

const TagContainer = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  max-width: 340px;
  margin: 0px auto 80px;

  ${ds.Tag} {
    margin: 5px;
  }
`
